"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvilTokenFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var EvilTokenFactory = /** @class */ (function (_super) {
    __extends(EvilTokenFactory, _super);
    function EvilTokenFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    EvilTokenFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    EvilTokenFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    EvilTokenFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    EvilTokenFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    EvilTokenFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return EvilTokenFactory;
}(contracts_1.ContractFactory));
exports.EvilTokenFactory = EvilTokenFactory;
var _abi = [
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060b68061001f6000396000f3fe608060405260043610601f5760003560e01c8063313ce567146022576020565b5b005b348015602d57600080fd5b5060346048565b604051603f91906067565b60405180910390f35b600090565b600060ff82169050919050565b606181604d565b82525050565b6000602082019050607a6000830184605a565b9291505056fea26469706673582212203db6639e27e1dbd72edaef4004a7ba5cf35443c7c0222b75c4732b847c5b0d9564736f6c634300080a0033";
